export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right' | 'center';
export type StepType = 'passive' | 'interactive';

export interface TutorialStep {
  id: string;
  type: StepType;
  target: string | null;
  title: string;
  description: string;
  position: TooltipPosition;
  interactionHint?: string;
}

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 'welcome',
    type: 'passive',
    target: null,
    title: 'Welcome to Stride',
    description: "Your work moves from start to finish on a race track. Let's get you set up in under a minute.",
    position: 'center',
  },
  {
    id: 'create-task',
    type: 'interactive',
    target: 'quick-add',
    title: 'Add a task to your track',
    description: "Type anything — like 'Review designs' or 'Write docs'",
    position: 'bottom',
    interactionHint: 'Create a task to continue...',
  },
  {
    id: 'the-track',
    type: 'passive',
    target: 'race-track',
    title: 'This is your track',
    description: 'Your task appears here. Each task holds subtasks — small chips you drag left to right to show progress.',
    position: 'top',
  },
  {
    id: 'add-subtask',
    type: 'interactive',
    target: 'first-track-add-subtask',
    title: 'Add a subtask',
    description: "Subtasks are what you drag to show progress. Click '+ Add subtask' and type a work item.",
    position: 'top',
    interactionHint: 'Add a subtask to continue...',
  },
  {
    id: 'drag-chip',
    type: 'interactive',
    target: 'first-subtask-chip',
    title: 'Drag to show progress',
    description: 'Drag the chip to the right — further right means more progress. Your task updates automatically.',
    position: 'top',
    interactionHint: 'Drag the chip to continue...',
  },
  {
    id: 'timeline',
    type: 'passive',
    target: 'timeline-panel',
    title: 'Schedule your day',
    description: 'Drag any subtask chip from the track into the timeline to block time for it.',
    position: 'left',
  },
  {
    id: 'other-views',
    type: 'passive',
    target: 'view-selector',
    title: "There's more to explore",
    description: 'Backlog to plan ahead, Recurring for repeating tasks, Summary for weekly reviews.',
    position: 'bottom',
  },
  {
    id: 'done',
    type: 'passive',
    target: null,
    title: "You're ready to race",
    description: 'Explore at your own pace. Press ⌘K anytime to search, navigate, or replay this tour.',
    position: 'center',
  },
];

export const TOTAL_STEPS = TUTORIAL_STEPS.length;
